<script setup lang="ts">
/* Portage de app/layouts/minimal.vue : pleine hauteur, fond portail, sans
 * header (pages /forbidden, 404, écran d'erreur de boot).
 * Le Toaster et l'hôte des confirmations vivent dans App.vue, pas ici. */
</script>

<template>
  <div class="flex flex-col min-h-screen bg-pbg text-ptext font-sans">
    <main class="flex-1">
      <slot />
    </main>
  </div>
</template>
